const vt = (e, s) => {
  let B = !0;
  const L = { x: 0, y: 0 }, f = { x: 0, y: 0 }, c = { x: 0, y: 0 }, T = new Proxy(
    { x: 0, y: 0 },
    {
      set(t, n, i) {
        return t[n] === i || (t[n] = i, (t.x >= 10 || t.y >= 10) && S(!0)), !0;
      }
    }
  ), l = new Proxy(
    { x: !1, y: !1 },
    {
      set(t, n, i) {
        return t[n] === i || (t[n] = i, t.x || t.y ? (e.setAttribute("has-overflow", "true"), e.addEventListener("pointerdown", K), e.addEventListener("wheel", Z, { passive: !1 })) : (e.removeAttribute("has-overflow"), e.removeEventListener("pointerdown", K), e.removeEventListener("wheel", Z))), !0;
      }
    }
  );
  let x = 300, p = null, h = !1, w = 300, d = 300, $ = 300, G = 300;
  const D = { start: 0, end: 0 }, R = { start: 0, end: 0 };
  let V = [], E = null, k = null, X = null, N = !1, W, v = 1;
  function at() {
    e == null || e.setAttribute("blossom-carousel", "true"), E = (e == null ? void 0 : e.querySelectorAll("a[href]")) || null, E == null || E.forEach((i) => {
      i.addEventListener("click", U);
    }), window.addEventListener("keydown", tt), e.addEventListener("scroll", z), k = new ResizeObserver(j), k.observe(e), X = new MutationObserver(st), X.observe(e, {
      attributes: !1,
      childList: !0,
      subtree: !1
    });
    const t = window.matchMedia(
      "(hover: hover) and (pointer: fine)"
    ).matches;
    v = e.closest('[dir="rtl"]') ? -1 : 1;
    const { scrollSnapType: n } = window.getComputedStyle(e);
    N = n !== "none", e.style.setProperty("--snap-type", n), t && (e.style["scroll-snap-type"] = "none"), e.setAttribute("has-repeat", s != null && s.repeat ? "true" : "false"), W = yt((i) => {
      (i === e || e.contains(i)) && S(!1);
    });
  }
  function rt() {
    e.removeAttribute("blossom-carousel"), k == null || k.disconnect(), X == null || X.disconnect(), p && cancelAnimationFrame(p), window.removeEventListener("keydown", tt), e.removeEventListener("scroll", z), E == null || E.forEach((t) => {
      t.removeEventListener("click", U);
    }), W == null || W();
  }
  function U(t) {
    T.x > 10 && t.preventDefault();
  }
  function j() {
    if (!e) return;
    const t = "ontouchmove" in window;
    w = e.scrollWidth, d = e.clientWidth, $ = e.scrollHeight, G = e.clientHeight;
    const n = window.getComputedStyle(e);
    l.x = !t && w > d && ["auto", "scroll"].includes(n.getPropertyValue("overflow-x")), l.y = !t && $ > G && ["auto", "scroll"].includes(n.getPropertyValue("overflow-y")), D.end = parseInt(n.paddingInlineEnd) || 0, D.start = parseInt(n.paddingInlineStart) || 0, R.start = parseInt(n.scrollPaddingInlineStart) || 0, R.end = parseInt(n.scrollPaddingInlineEnd) || 0, v = e.closest('[dir="rtl"]') ? -1 : 1, x = (w - d - 4) * v, V = N ? lt(e) : [], s != null && s.repeat && F(null, null);
  }
  function st() {
    j();
  }
  function lt(t) {
    let n = [], i = 0;
    const a = (r) => {
      if (i++, i > 100) return;
      const P = window.getComputedStyle(r).scrollSnapAlign;
      if (P !== "none") {
        n.push({
          align: P,
          el: r
        });
        return;
      }
      const u = r.children;
      if (u.length !== 0)
        for (let g of u)
          a(g);
    };
    a(t);
    const q = t.getBoundingClientRect();
    let y = n.map(({ el: r, align: m }, P) => {
      const u = r.getBoundingClientRect(), g = r.clientWidth, _ = u.left - q.left + t.scrollLeft;
      switch (m) {
        case "start":
          return _ - R.start;
        case "end":
          return _ + g - d + R.end;
        case "center":
          return _ + g * 0.5 - d / 2;
        default:
          return null;
      }
    });
    return y = y.filter((r) => r !== null).reduce((r, m) => (r[r.length - 1] !== m && r.push(m), r), []), y;
  }
  function z() {
    if (s != null && s.repeat) {
      F(null, null);
      return;
    }
    if (h || !e) return;
    const t = e.scrollLeft;
    if (t < 0) {
      const n = t * -1;
      Y(n);
    } else if (t > w - d) {
      const n = t * -1 + w - d;
      Y(n);
    }
  }
  const o = {
    x: 0,
    y: 0
  };
  function K(t) {
    e && (l.x && (o.x = e.scrollLeft, L.x = t.clientX, c.x = 0), l.y && (o.y = e.scrollTop, L.y = t.clientY, c.y = 0), T.x = 0, h = !0, window.addEventListener("pointermove", J), window.addEventListener("pointerup", Q));
  }
  function J(t) {
    if (t.preventDefault(), l.x) {
      const n = L.x - t.clientX;
      f.x += n, c.x += n, L.x = t.clientX, T.x += Math.abs(n);
    }
    if (l.y) {
      const n = L.y - t.clientY;
      f.y += n, c.y += n, L.y = t.clientY, T.y += Math.abs(n);
    }
  }
  function Q() {
    window.removeEventListener("pointermove", J), window.removeEventListener("pointerup", Q), h = !1, !(T.x <= 10) && (l.x && (c.x *= 2), l.y && (c.y *= 2), ft(), xt());
  }
  function Z(t) {
    if (Math.abs(t.deltaX) > Math.abs(t.deltaY)) {
      if (S(!1), h || !e) return;
      l.x && (o.x = e.scrollLeft), l.y && (o.y = e.scrollTop);
    }
  }
  function tt(t) {
    ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(t.key) && S(!1);
  }
  function ft() {
    const i = (it(
      wt({ axis: "x" }),
      Math.min((w - d) * v, 0),
      Math.max((w - d) * v, 0)
    ) - f.x) * (1 - b) * (1 / b);
    c.x = i;
  }
  function F(t, n) {
    if (!e) return;
    const i = n ?? e.scrollLeft, a = D.start - i, q = i - (w - d - D.end), y = Array.from(e.children);
    let r = 0;
    for (let u = y.length - 1; u >= y.length / 2; u--) {
      const g = r > a ? 0 : -(w - d);
      r += y[u].clientWidth, y[u].style.translate = `${g}px 0`;
    }
    let m = 0;
    for (let u = 0; u < y.length / 2; u++) {
      const g = m > q ? 0 : w - d;
      m += y[u].clientWidth, y[u].style.translate = `${g}px 0`;
    }
    if (h) return;
    const P = i > x ? 4 : i < 4 ? x : null;
    P && (I = !0, e.scrollTo({
      left: P,
      behavior: "instant"
    }));
  }
  const b = 0.72, O = 0.12;
  let et = !1;
  function S(t) {
    e && (t && !et ? (H = performance.now(), l.x && (f.x = e.scrollLeft), l.y && (f.y = e.scrollTop), p || (p = requestAnimationFrame(nt))) : t || (p && cancelAnimationFrame(p), p = null), et = t, B = !t, e.setAttribute("has-snap", B ? "true" : "false"));
  }
  let M = 0, H = 0;
  function nt(t) {
    p = requestAnimationFrame(nt), M = t - H, e && (l.x && (c.x *= b, h ? o.x = C(o.x, f.x, b, M) : (f.x += c.x, o.x = C(o.x, f.x, O, M))), l.y && (c.y *= b, h ? o.y = C(o.y, f.y, b, M) : (f.y += c.y, o.y = C(o.y, f.y, O, M))), s != null && s.repeat && (o.x > x && (o.x = f.x = 4), o.x < 4 && (o.x = f.x = x)), I = !0, e.scrollTo({
      left: o.x,
      top: o.y,
      behavior: "instant"
    }), s != null && s.repeat ? F(null, o.x) : ut(ot(o.x, 2)), H = t);
  }
  let A = 0;
  function ut(t) {
    if (!e) return;
    const n = x;
    let i = 0;
    if (t * v <= 0 ? i = h ? t * -0.2 : 0 : t * v > n * v && (i = h ? (t - n) * -0.2 : 0), A = C(
      A,
      i,
      h ? 0.8 : O,
      M
    ), Math.abs(A) > 0.01) {
      if (Y(A).defaultPrevented) return;
      e.style.transform = `translateX(${ot(A, 3)}px)`;
      return;
    }
    e.style.transform = "", A = 0;
  }
  function Y(t) {
    const n = new CustomEvent("overscroll", {
      bubbles: !0,
      cancelable: !0,
      detail: { left: t }
    });
    return e == null || e.dispatchEvent(n), n;
  }
  let I = !1;
  const ct = e.scrollTo.bind(e);
  e.scrollTo = function(t) {
    I === !0 || S(!1), I = !1, ct(t);
  };
  const dt = e.scrollBy.bind(e);
  e.scrollBy = function(t) {
    I === !0 || S(!1), I = !1, dt(t);
  };
  function yt(t) {
    const n = [], i = Element.prototype.scrollIntoView;
    return i && (Element.prototype.scrollIntoView = function(a) {
      return t(this, "scrollIntoView", [a]), i.call(this, a);
    }, n.push(() => {
      Element.prototype.scrollIntoView = i;
    })), () => n.forEach((a) => a());
  }
  function ht({ axis: t = "x" }) {
    return f[t] + c[t] / (1 - b);
  }
  function wt({ axis: t = "x" }) {
    const n = ht({ axis: t });
    return V.length ? V.reduce(
      (i, a) => Math.abs(a - n) < Math.abs(i - n) ? a : i
    ) : it(n, Math.min(x, 0), Math.max(x, 0));
  }
  function xt() {
    const t = (n) => {
      n.preventDefault(), n.stopPropagation(), window.removeEventListener("click", t, !0);
    };
    window.addEventListener("click", t, !0);
  }
  function pt(t, n, i) {
    return (1 - i) * t + i * n;
  }
  function C(t, n, i, a) {
    return pt(t, n, 1 - Math.exp(Math.log(1 - i) * (a / 16.666666666666668)));
  }
  function it(t, n, i) {
    return t < n ? n : t > i ? i : t;
  }
  function ot(t, n = 0) {
    const i = Math.pow(10, n);
    return Math.round(t * i) / i;
  }
  return {
    snap: B,
    hasOverflow: l,
    init: at,
    destroy: rt
  };
};
export {
  vt as Blossom
};
